<app-top-header
    class="top-header"
    [financialData]="financialData"
    [brand]="brand"
    [model]="model"
    [isPortraitDevice]="isPortraitDevice"
    (isOpenedFinancialCart)="isOpenedFinancialCart(isFinancialCartOpen)"
></app-top-header>

<div *ngIf="isPortraitDevice && stepIdSelected > 0" class="navigation-step">
    <app-navigation-step [steps]="steps" [stepIdSelected]="stepIdSelected"></app-navigation-step>
</div>
